// Payment API Types
export interface Payment {
  id: number;
  paymentDate: string | Date;
  totalPaymentAmount: number;
}

export interface PaymentTotal {
  id: number;
  paymentDate: string | Date;
  totalAmountWithoutTax: number;
  totalCurrentRewardAmount: number;
  totalCarryoverAmount: number;
  totalAdministrativeFee: number;
  totalPaymentAmount: number;
  totalPendingAmount: number;
  totalForfeitedAmount: number;
}

export interface PaymentDetail {
  id: number;
  paymentDate: string | Date;
  clientId: number;
  clientName?: string;
  partnerId: number;
  partnerName?: string;
  affiliateId?: string;
  amount: number;
  currentRewardAmount: number;
  carryoverAmount: number;
  rawCarryoverAmount: number;
  administrativeFee: number;
  totalAmount: number;
  pendingAmount: number;
  paymentStatus: 1 | 2 | 3 | 4 | 99; // 1: 保留, 2: 未振込, 3: 振込済み, 4: 失効, 99: エラー
  paymentType: 1 | 2 | 3; // 1: 通常, 2: 退会精算, 3: 退会失効
  forfeitedAmount: number;
  affiliateStatus: 0 | 1; // 0: 無効, 1: 有効
  memo?: string;
}

export interface PaymentDetailItem {
  id: number;
  paymentId: number;
  orderId: string;
  clientId: number;
  clientName?: string;
  ecSiteOrderId: string;
  ecSiteClientId: string;
  partnerId: number;
  partnerName?: string;
  affiliateId: string;
  orderDate: string | Date;
  approvedAt?: string | Date;
  rewardAmount: number;
  invoiceDetailId: number;
}

// Payment status constants
export const PaymentStatusLabels: Record<number, string> = {
  1: '保留',
  2: '未振込',
  3: '振込済み',
  4: '失効',
  99: 'エラー'
};

export const PaymentTypeLabels: Record<number, string> = {
  1: '通常',
  2: '退会精算',
  3: '退会失効'
};

// Utility function
export const formatCurrency = (amount: number): string => {
  return amount.toLocaleString() + '円';
};
